import { asColor } from '@atlassian/jira-issue-epic-color/src/common/utils.tsx';
import type { IssueParent } from '../../model/issue-parent/types';
import {
	loadIssueParents as fetch,
	type LoadIssueParentsRestResponse,
} from '../../rest/load-issue-parents';

import 'rxjs/add/operator/map';

export const transformer = (response: LoadIssueParentsRestResponse): IssueParent[] =>
	response.epics.values.map(({ id, key, summary, issueTypeDetails, color, epicColor }) => ({
		id: String(id),
		key,
		summary,
		issueType: {
			id: issueTypeDetails.id,
			name: issueTypeDetails.name,
			iconUrl: issueTypeDetails.iconUrl,
		},
		color: asColor(color || epicColor),
	}));

const loadEpicsService = (boardId: string) => fetch(boardId).map(transformer);

export default loadEpicsService;
